import { Box, Grid, Tooltip, Typography, useTheme } from '@mui/material'
import { renderColorByString } from '../DataGrid/renderColorByString'
import { formatCurrency } from '../DealsKanban/aggregateStageTotals'

const AccountingDrawerHeader = ({
  organization,
  billingContact,
  newDeal,
  totals,
}: {
  organization: any
  billingContact: any
  newDeal: any
  totals: any
}) => {
  const theme = useTheme()
  return (
    <Box
      sx={{
        p: 3,
        backgroundColor: theme.palette.background.paper,
        borderRadius: '8px',
        boxShadow: '0 2px 6px rgba(0, 0, 0, 0.1)',
      }}
    >
      <Grid
        container
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          overflowY: 'hidden',
        }}
      >
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
            <Tooltip title={<Typography>{'Organization Name'}</Typography>} placement="right">
              <Typography
                variant="h5"
                sx={{ fontWeight: 'bold', textAlign: 'left', color: theme.palette.text.primary }}
              >
                {organization?.name || 'N/A'}
              </Typography>
            </Tooltip>
            <Box>
              <Tooltip title={<Typography>{'Legal Entity Name'}</Typography>} placement="left">
                <Typography
                  sx={{ textAlign: 'left', fontWeight: 'bold', fontStyle: 'italic', color: theme.palette.text.primary }}
                >
                  {organization?.dba || 'N/A'}{' '}
                </Typography>
              </Tooltip>
            </Box>
            <Box>
              <Tooltip title={<Typography>{'Organization Status'}</Typography>} placement="left">
                <Typography
                  sx={{
                    textAlign: 'left',
                    color: renderColorByString(organization?.status || ''),
                  }}
                >
                  {organization?.status || 'N/A'}
                </Typography>
              </Tooltip>
            </Box>
          </Box>
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={4} xl={4} sx={{ p: 1, pl: 1.5, pr: 1.5 }}>
          <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography variant="subtitle2" color="textSecondary" sx={{ textAlign: 'left' }}>
              Billing Contact
            </Typography>
            <Typography sx={{ textAlign: 'left', color: theme.palette.text.primary }}>
              {billingContact?.name || 'N/A'}
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography variant="subtitle2" color="textSecondary" sx={{ textAlign: 'left' }}>
              Billing Email
            </Typography>
            <Typography
              noWrap
              sx={{
                textAlign: 'left',
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                color: theme.palette.text.primary,
              }}
            >
              {billingContact?.email || 'N/A'}
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography variant="subtitle2" color="textSecondary" sx={{ textAlign: 'left' }}>
              Billing Phone
            </Typography>
            <Typography sx={{ textAlign: 'left', color: theme.palette.text.primary }}>
              {billingContact?.phone || 'N/A'}
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography variant="subtitle2" color="textSecondary" sx={{ textAlign: 'left' }}>
              Website
            </Typography>
            <Typography
              noWrap
              sx={{
                textAlign: 'left',
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                color: theme.palette.text.primary,
              }}
            >
              {organization?.website || 'N/A'}
            </Typography>
          </Box>
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={4} xl={4} sx={{ p: 1, pl: 1.5, pr: 1.5 }}>
          <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography variant="subtitle2" color="textSecondary" sx={{ textAlign: 'left' }}>
              Street
            </Typography>
            <Typography sx={{ textAlign: 'left', color: theme.palette.text.primary }}>
              {organization?.street || 'N/A'}
            </Typography>
          </Box>

          <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography variant="subtitle2" color="textSecondary" sx={{ textAlign: 'left' }}>
              City
            </Typography>
            <Typography sx={{ textAlign: 'left', color: theme.palette.text.primary }}>
              {organization?.city || 'N/A'}
            </Typography>
          </Box>

          <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography variant="subtitle2" color="textSecondary" sx={{ textAlign: 'left' }}>
              State
            </Typography>
            <Typography sx={{ textAlign: 'left', color: theme.palette.text.primary }}>
              {organization?.state || 'N/A'}
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography variant="subtitle2" color="textSecondary" sx={{ textAlign: 'left' }}>
              Zip
            </Typography>
            <Typography sx={{ textAlign: 'left', color: theme.palette.text.primary }}>
              {organization?.Zip || 'N/A'}
            </Typography>
          </Box>
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={4} xl={4} sx={{ p: 1, pl: 1.5, pr: 1.5 }}>
          <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography variant="subtitle2" color="textSecondary" sx={{ textAlign: 'left' }}>
              Total Gross Profit
            </Typography>
            <Typography sx={{ color: theme.palette.success.main, textAlign: 'left' }}>
              {totals?.grossProfit ? formatCurrency(totals?.grossProfit) : 'N/A'}
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
            {newDeal?.type === 'IO' ? (
              <Typography variant="subtitle2" color="textSecondary" sx={{ textAlign: 'left' }}>
                Monthly Total
              </Typography>
            ) : (
              <Typography variant="subtitle2" color="textSecondary" sx={{ textAlign: 'left' }}>
                Monthly Total
              </Typography>
            )}

            <Typography sx={{ color: theme.palette.success.main, textAlign: 'left' }}>
              {totals?.monthlyTotal ? formatCurrency(totals?.monthlyTotal) : 'N/A'}
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography variant="subtitle2" color="textSecondary" sx={{ textAlign: 'left' }}>
              Total Contract Amount
            </Typography>
            <Typography sx={{ color: theme.palette.success.main, textAlign: 'left' }}>
              {totals?.total ? formatCurrency(totals?.total) : 'N/A'}
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography variant="subtitle2" color="textSecondary" sx={{ textAlign: 'left' }}>
              Implementation Fee
            </Typography>
            <Typography sx={{ color: theme.palette.success.main, textAlign: 'left' }}>
              {totals?.implementationFee ? formatCurrency(totals?.implementationFee) : 'N/A'}
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>
  )
}

export default AccountingDrawerHeader
